// src/config/config.js
// Configuración centralizada para URLs y variables de entorno

/**
 * Obtiene la URL del backend con fallback robusto
 * @returns {string} URL del backend
 */
export const getBackendUrl = () => {
  // Intentar obtener desde variable de entorno
  const envUrl = import.meta.env.VITE_BACKEND_URL;
  
  // Logging para debug en desarrollo
  if (import.meta.env.DEV) {
    console.log('🔗 Config Debug:', {
      VITE_BACKEND_URL: envUrl,
      isDev: import.meta.env.DEV,
      mode: import.meta.env.MODE
    });
  }
  
  // Fallbacks robustos
  if (envUrl && envUrl !== 'undefined' && envUrl.trim() !== '') {
    return envUrl;
  }
  
  // Detectar entorno y usar URL apropiada
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:3001'; // ARQUITECTURA_PUERTOS.md - Backend Principal en 3001
  }
  
  // Producción
  return 'https://edutechpulselab.com';
};

/**
 * Obtiene la URL base del servicio Analytics V4 (read-only)
 * - Permite override vía VITE_ANALYTICS_V4_URL
 * - En local (localhost/127.0.0.1) usa puerto 3004
 * - En producción usa el mismo dominio
 * @returns {string} URL base del host (sin paths)
 */
export const getAnalyticsV4Url = () => {
  const envUrl = import.meta.env.VITE_ANALYTICS_V4_URL;

  if (import.meta.env.DEV) {
    console.log('📊 Analytics V4 Config Debug:', {
      VITE_ANALYTICS_V4_URL: envUrl,
      isDev: import.meta.env.DEV,
      mode: import.meta.env.MODE
    });
  }

  if (envUrl && envUrl !== 'undefined' && envUrl.trim() !== '') {
    return envUrl;
  }

  // Analytics V4 tiene su propio servidor independiente en puerto 3006 en desarrollo
  // En producción usa el backend principal con proxy
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:3006';
  }

  return getBackendUrl();
};

/**
 * Configuración de la aplicación
 */
export const config = {
  api: {
    baseUrl: getBackendUrl(),
    timeout: 30000, // 30 segundos
    retries: 3
  },
  app: {
    name: 'Edutech Pulse Lab',
    version: '1.0.0'
  }
};

export default config;